// Basic UI components
export { Button } from "./Button";
export type { ButtonProps } from "./Button";

export { Input } from "./Input";
export type { InputProps } from "./Input";

export { Card, CardHeader, CardContent, CardFooter } from "./Card";
export type { CardProps } from "./Card";
export { CardTitle } from "./CardTitle";
export type { CardTitleProps } from "./CardTitle";

export {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalDescription,
  ModalContent,
  ModalFooter,
} from "./Modal";
export type { ModalProps } from "./Modal";

export { Loading } from "./Loading";
export type { LoadingProps } from "./Loading";

export {
  ConfirmationDialog,
  useConfirmationDialog,
} from "./confirmation-dialog";

// Components to be implemented
// export { Dropdown } from './Dropdown';
// export { Toast } from './Toast';

// Placeholder export to prevent build errors
export const UI_COMPONENTS_VERSION = "0.1.0";
